function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "31",
  height: "31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.402.5c.715 0 1.284.404 1.592.935l.059.107.002.004h-.001L20.71 9.02l8.09 1.216c.726.08 1.24.631 1.452 1.197l.006.017a1.786 1.786 0 01-.448 1.88l-.002.001-5.887 5.832 1.38 8.222H25.3c.145.702-.174 1.36-.658 1.775l-.029.024-.032.02c-.568.355-1.235.433-1.89.143l.005-.026-7.24-3.91-7.254 3.918-.014.008c-.616.308-1.35.218-1.91-.133l-.032-.02-.03-.024c-.483-.415-.803-1.074-.658-1.775l1.378-8.221-5.886-5.833-.001-.002a1.786 1.786 0 01-.45-1.879l.006-.017c.213-.566.727-1.116 1.453-1.197l8.088-1.216 3.659-7.475.002-.004C14.092.972 14.683.5 15.402.5z",
  fill: "#FACC15",
  stroke: "#FACC15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.656 17.763a4.753 4.753 0 01-4.297 2.656 4.753 4.753 0 01-4.297-2.656c-.234-.469.235-.86.704-.742 1.093.313 2.304.469 3.593.469 1.25 0 2.461-.156 3.555-.469.508-.117.976.273.742.742z",
  fill: "#151417"
}), /*#__PURE__*/React.createElement("rect", {
  x: "17.655",
  y: "12.214",
  width: "4",
  height: "1.5",
  rx: ".75",
  transform: "rotate(26.447 17.655 12.214)",
  fill: "#151417"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9.771",
  y: "13.824",
  width: "4",
  height: "1.5",
  rx: ".75",
  transform: "rotate(-22.05 9.77 13.824)",
  fill: "#151417"
}));